import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ACTIVITIES, FIND_ALL_LEADS_PAGINATION, LEAD, LEADS, NOTES } from '../graphql/query/lead.queries';
import { map, Observable } from 'rxjs';
import { CREATE_ACTIVITY, CREATE_LEAD, CREATE_NOTES, REMOVE_ACTIVITY, REMOVE_LEAD, REMOVE_NOTES, UPDATE_LEAD } from '../graphql/mutation/lead.mutation';

@Injectable({
  providedIn: 'root',
})
export class LeadService {
  constructor(private apollo: Apollo) {}

  fetchLeads(search: any, status?: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: LEADS,
        variables: {
          search,
          status
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.leads || []));
  }

  fetchLeadById(id: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: LEAD,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.lead || []));
  }

    createLead(createLeadsInput: any): Observable<any> {
      return this.apollo
        .use('project')
        .mutate({
          mutation: CREATE_LEAD,
          variables: { 
            createLeadInput: createLeadsInput,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
          map((result: any) => result.data.createLead || [])
        );
    }

    updateLead(id: number,updateLeadsInput: any): Observable<any> {
      return this.apollo
        .use('project')
        .mutate({
          mutation: UPDATE_LEAD,
          variables: { 
            id: id,
            updateLeadInput: updateLeadsInput,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
          map((result: any) => result.data.updateLead || [])
        );
    }
    
    removeLead(id: any): Observable<any> {
      return this.apollo
        .use('project')
        .mutate({
          mutation: REMOVE_LEAD,
          variables: { 
            id: id,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
          map((result: any) => result.data.removeLead || [])
        );
    }

    createNotes(createNoteInput: any): Observable<any> {
      return this.apollo
        .use('project')
        .mutate({
          mutation: CREATE_NOTES,
          variables: { 
            createNoteInput: createNoteInput,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
          map((result: any) => result.data.createNotes || [])
        );
    }

    fetchNotes(leadId:any,search: any): Observable<any> {
      return this.apollo
        .use('project')
        .watchQuery<any>({
          query: NOTES,
          variables: {
            leadId,
            search          
          },
          fetchPolicy: 'network-only',
        })
        .valueChanges.pipe(map((result) => result.data?.notes || []));
    }

    removeNotes(id: any): Observable<any> {
      return this.apollo
        .use('project')
        .mutate({
          mutation: REMOVE_NOTES,
          variables: { 
            id: id,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
          map((result: any) => result.data.removeNote || [])
        );
    }

    createActivity(createActivityInput: any): Observable<any> {
      return this.apollo
        .use('project')
        .mutate({
          mutation: CREATE_ACTIVITY,
          variables: { 
            createActivityInput: createActivityInput,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
          map((result: any) => result.data.createActivity || [])
        );
    }

    removeActivity(id: any): Observable<any> {
      return this.apollo
        .use('project')
        .mutate({
          mutation: REMOVE_ACTIVITY,
          variables: { 
            id: id,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
          map((result: any) => result.data.removeActivity || [])
        );
    }

    fetchActivities(leadId:any,search: any): Observable<any> {
      return this.apollo
        .use('project')
        .watchQuery<any>({
          query: ACTIVITIES,
          variables: {
            leadId,
            search          
          },
          fetchPolicy: 'network-only',
        })
        .valueChanges.pipe(map((result) => result.data?.activities || []));
    }

    findAllLeadsWithPagination(
            input: any,
            status?: any
          ): Observable<any> {
            return this.apollo
              .use('project')
              .watchQuery<any>({
                query: FIND_ALL_LEADS_PAGINATION,
                variables: {
                  input,
                  status
                },
                fetchPolicy: 'network-only',
              })
              .valueChanges.pipe(
                map((result) => result.data?.findAllLeadsWithPagination || [])
              );
          }
}
